import React, { useState } from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL, ROUTE, SIGNIN_BG } from "../../Constant";
import { useForgotPasswordMutation } from "./useForgotPasswordMutation";
import { Step1 } from "./common/Step1";
import { Step2 } from "./common/Step2";
import { useAppBranding } from "../../Hook";

export const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState<1 | 2>(1);

  const {logoUrl } = useAppBranding();

  const { sendOtpMutation, resetPasswordMutation } = useForgotPasswordMutation({
    email,
    otp,
    password,
    setStep,
    navigate,
  });

  const handleRequestOtp = () => {
    if (!email) {
      message.error("Please enter your email address.");
      return;
    }
    sendOtpMutation.mutate(email);
  };

  const handleResetPassword = () => {
    if (!otp) {
      message.error("Please enter the OTP.");
      return;
    }
    if (!password) {
      message.error("Please enter your new password.");
      return;
    }
    if (password.length < 6) {
      message.error("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }
    resetPasswordMutation.mutate();
  };

  return (
    <div className="flex min-h-screen">
      <div className="flex-1 flex items-center justify-center bg-white">
        <div className="w-full max-w-md p-8">
          <div className="flex justify-start mb-6">
            <img src={`${IMAGE_URL}/${logoUrl}`} alt="Logo" className="w-10" />
          </div>

          <h2 className="text-2xl font-semibold text-start mb-2">
            Reset Password
          </h2>
          <p className="text-gray-500 text-start mb-6 text-sm">
            {step === 1
              ? "Enter your registered email address to receive a one-time password."
              : "Enter the OTP code sent to your email and set your new password."}
          </p>

          {step === 1 ? (
            <Step1
              email={email}
              setEmail={setEmail}
              onSubmit={handleRequestOtp}
              loading={sendOtpMutation.isPending}
              onBackToSignIn={() => navigate("/")}
            />
          ) : (
            <Step2
              otp={otp}
              setOtp={setOtp}
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              onSubmit={handleResetPassword}
              loading={resetPasswordMutation.isPending}
              onRequestNewOtp={() => setStep(1)}
            />
          )}
        </div>
      </div>

      <div
        className="flex-1 hidden lg:block bg-cover bg-center"
        style={{
          backgroundImage: `url('${IMAGE_URL}/${SIGNIN_BG}')`,
        }}
      ></div>
    </div>
  );
};
